import type React from 'react';

import { Waypoint } from '#src/app/shared/components/scroll';
import { useTrackOnce, useTrackView } from '#src/app/shared/hooks/tracking';

import type { DecisionMakerSectionTracking } from '../../types';

/**
 * Tracks `sap_dm_section_view` on mount, and `sap_dm_section_impression` the first time this point on the
 * page scrolls into view. Drop it at the bottom of the decision-maker section, keyed by its status, so each
 * state gets its own view and impression: a remount that's already in view tracks the impression straight
 * away. Renders nothing.
 */
export const TrackDecisionMakerSection: React.FC<Props> = ({ properties }) => {
	// once per mount: a Remove that leaves some changes the count but isn't another view
	useTrackView('sap_dm_section_view', properties);
	const trackOnce = useTrackOnce();

	// on enter, not once scrolled past: a state that shows above the viewport hasn't been seen
	return <Waypoint onEnter={() => void trackOnce('sap_dm_section_impression', properties)} />;
};

type Props = {
	/** What the section shows. */
	properties: DecisionMakerSectionTracking;
};
